import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
} from '@ngx-translate/core';
import { SentryService } from '@rd-lib/sentry/sentry.service';
import { ENV, TENANT_NAME } from '@rd/core/tokens/rd-lib.token';
import { EnvironmentType } from 'global-types';

@Injectable({
  providedIn: 'root',
})
export class RdMissingTranslationHandler implements MissingTranslationHandler {
  constructor(
    private sentryService: SentryService,
    private router: Router,
    @Inject(TENANT_NAME) private tenantName: string,
    @Inject(ENV) private env: EnvironmentType,
  ) {}

  handle(params: MissingTranslationHandlerParams) {
    // this.sentryService.manualError(`
    //   Tenant: ${this.tenantName}, env: ${this.env}
    //   Missing translation key: ${params.key}
    //   Locale: ${params.translateService.currentLang}
    //   Routes: ${this.router.url}
    // `);

    return params.key;
  }
}
